import { Component, HostBinding, OnInit } from '@angular/core';

import { RegisterComponent } from '../../components/component-lookup';
import { FlexComponent } from '../flex-component/flex.component';

@RegisterComponent('FlexCardContainer')
@Component({
  selector: 'app-flex-card-container',
  standalone: true,
  imports: [],
  templateUrl: './flex-card-container.component.html',
  styleUrl: './flex-card-container.component.scss'
})
export class FlexCardContainerComponent extends FlexComponent implements OnInit {
  @HostBinding('class') get cssClass() {
    return `flex-cards flex-cards-${this.children().length}`;
  }
  
  override ngOnInit(): void {
    super.ngOnInit();
  }
}
